export const CHANGE_ID = 'CHANGE_ID';
export const CHANGE_PASS = 'CHANGE_PASS';
export const CHANGE_IS_ERR = 'CHANGE_IS_ERR';
export const CHANGE_IS_LOGIN = 'CHANGE_IS_LOGIN';

export function changeIdAction(id) {
    return {
        type: CHANGE_ID,
        id: id
    };
}

export function changePassAction(pass) {
    return {
        type: CHANGE_PASS,
        pass: pass
    };
}

export function changeIsErrAction(isErr) {
    return {
        type: CHANGE_IS_ERR,
        isErr: isErr
    };
}

export function changeIsLoginAction(isLogin) {
    return {
        type: CHANGE_IS_LOGIN,
        isLogin: isLogin
    };
}